module.exports = __webpack_public_path__ + "img/calendar.ea005d90.svg";